<template>

  <div class="col-12 pt-3">
    <div class="row">
      <div class="col-12">
        <div class="table-responsive mb-3" style="overflow-x: visible">
          <table class="table table-striped table-sm" id="timesheet_submit_table">
            <thead>
            <tr>
              <th v-for="(column, index) in columns" @click="sort(index, column)"
                  :class="(sortable && column.sortable ? 'sortable ' : '') + (sortColumn === index ? (sortType === 'desc' ? ' sorting-desc' : ' sorting-asc') : '') + column.class"
                  :style="{width: column.width ? column.width : 'auto'}">

                <div v-if="column.class === 'days'"><span>{{ column.label }}</span></div>
                <span v-else>{{ column.label }}</span>
                <i class="fa float-right" v-if="column.sortable"
                   :class="(sortColumn === index ? (sortType === 'desc' ? ' fas fa-sort-alpha-down' : ' fas fa-sort-alpha-up') : 'fas fa-filter')"></i>
                <!--                <i class="fas fa-sort-alpha-down"></i>-->
              </th>
              <slot name="thead-tr"></slot>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, index) in paginated" @click="click(row, index)">
              <template v-for="column in columns">
                <td :class="column.class" v-if="!column.html && column.checkbox">
                  {{ collect(row, column.field) }}
                </td>
                <td :class="column.class" v-else-if="!column.html">
                  <div class="td_data_outer">
                    <div class="td_data">{{ collect(row, column.field) }}</div>
                  </div>
                </td>
                <td :class="column.class" v-if="column.html" v-html="collect(row, column.field)"></td>
              </template>
              <!--              <slot name="tbody-tr" :row="row"></slot>-->
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <td colspan="3" style="z-index: 999">
                <div class="td_data_outer">
                  <div class="td_data">
                    RUNNING TOTAL
                  </div>
                </div>
              </td>

              <td>
                <div class="td_data_outer">
                  <div class="td_data"></div>
                </div>
              </td>
              <td>
                <div class="td_data_outer">
                  <div class="td_data"></div>
                </div>
              </td>

              <td>
                <div class="td_data_outer">
                  <div class="td_data">mon</div>
                </div>
              </td>
              <td>
                <div class="td_data_outer">
                  <div class="td_data">tue</div>
                </div>
              </td>
              <td>
                <div class="td_data_outer">
                  <div class="td_data">wed</div>
                </div>
              </td>
              <td>
                <div class="td_data_outer">
                  <div class="td_data">thu</div>
                </div>
              </td>
              <td>
                <div class="td_data_outer">
                  <div class="td_data">fri</div>
                </div>
              </td>
              <td>
                <div class="td_data_outer">
                  <div class="td_data">sat</div>
                </div>
              </td>
              <td>
                <div class="td_data_outer">
                  <div class="td_data">sun</div>
                </div>
              </td>

              <td>
                <div class="td_data_outer">
                  <div class="td_data">hours</div>
                </div>
              </td>
              <td>
                <div class="td_data_outer">
                  <div class="td_data">invoice</div>
                </div>
              </td>
              <td>
                <div class="td_data_outer">
                  <div class="td_data">total units</div>
                </div>
              </td>
              <td>
                <div class="td_data_outer">
                  <div class="td_data">total b4</div>
                </div>
              </td>
              <td>
                <div class="td_data_outer">
                  <div class="td_data">release ret</div>
                </div>
              </td>
              <td>
                <div class="td_data_outer">
                  <div class="td_data">ret amount</div>
                </div>
              </td>
              <td>
                <div class="td_data_outer">
                  <div class="td_data">pre tax add</div>
                </div>
              </td>
              <td>
                <div class="td_data_outer">
                  <div class="td_data">post tax add</div>
                </div>
              </td>
              <td>
                <div class="td_data_outer">
                  <div class="td_data">pre tax ded</div>
                </div>
              </td>
              <td>
                <div class="td_data_outer">
                  <div class="td_data">post tax ded</div>
                </div>
              </td>
              <td>
                <div class="td_data_outer">
                  <div class="td_data">invoice total</div>
                </div>
              </td>
              <td>
                <div class="td_data_outer">
                  <div class="td_data">back next week</div>
                </div>
              </td>
              <td>
                <div class="td_data_outer">
                  <div class="td_data">with</div>
                </div>
              </td>
              <td>
                <div class="td_data_outer">
                  <div class="td_data">submit</div>
                </div>
              </td>
              <td>
                <div class="td_data_outer">
                  <div class="td_data">auth</div>
                </div>
              </td>
            </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>

</template>
<script>

export default {
  props: {
    title: {default: ""},
    columns: {required: true},
    rows: {required: true},
    sortable: {default: true},
    week: {required: true}
  },
  data() {
    return {
      sortColumn: -1,
      sortType: 'asc',
    }
  },
  mounted() {
    // this.sort(0);
  },
  methods: {
    sort(index, column) {
      if (column.sortable) {
        if (!this.sortable) {
          return;
        }
        if (this.sortColumn === index) {
          this.sortType = this.sortType === 'asc' ? 'desc' : 'asc';
        }
        else {
          this.sortType = 'asc';
          this.sortColumn = index;
        }
      }

    },
    click(row, index) {
      this.$emit("rowClick", row, index);
    },
    dig(obj, selector) {
      let result = obj;
      const splitter = selector.split('.');
      for (let i = 0; i < splitter.length; i++)
        if (typeof (result) === 'undefined')
          return undefined;
        else
          result = result[splitter[i]];
      return result;
    },
    collect(obj, field) {
      if (field === 'submit_to_genius') {
        // console.log(field)
      }
      else {
        if (typeof (field) === 'function') {
          return field(obj);
        }
        else if (typeof (field) === 'string') {
          return this.dig(obj, field);
        }
        else {
          return undefined;
        }
      }
    }
  },
  computed: {
    processedRows() {
      let computedRows = this.rows;

      if (this.sortable !== false) {
        computedRows = computedRows.sort((x, y) => {
          if (!this.columns[this.sortColumn]) {
            return 0;
          }

          const cook = (x) => {
            x = this.collect(x, this.columns[this.sortColumn].field);
            if (typeof (x) === 'string') {
              x = x.toLowerCase();
            }
            return x;
          };

          x = cook(x);
          y = cook(y);

          return (x < y ? -1 : (x > y ? 1 : 0)) * (this.sortType === 'desc' ? -1 : 1);
        })
      }

      return computedRows;
    },

    paginated() {
      return this.processedRows;
    }
  }
}
</script>

<style lang="scss">
input[type="number"]::-webkit-outer-spin-button, input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin:             0;
}

input[type="number"] {
  -moz-appearance: textfield;
  //width: 40px !important;
  width:           100% !important;
  display:         inline-block !important;
  vertical-align:  top;
}

#submit_timesheets_new {
  .pretty {
    margin-right: 0;
    //color:        white;
    height:       22px;

    &.certify_check {
      height: auto;

      input {
        height: 100%;
        max-height: 100%;
      }
    }

    input {
      width:      100% !important;
      height:     22px;
      max-height: 22px;
      min-height: 22px;
    }

    .state {
      height: 100%;

      .icon {
        font-size: 1em;
        left:      0;
        top:       0;
      }

      label {
        text-indent: 0;
        font-size: 0.9rem;

        &:before, &:after {
          height: 22px;
          width:  22px;
          top:    0;
        }
      }
    }
  }

  .pretty input:checked ~ .state .icon, .pretty input:checked ~ .state .svg, .pretty.p-toggle .state .icon, .pretty.p-toggle .state .svg {
    color:            white;
    background-color: $bc_1;
  }

  .table-responsive {
    height:     auto;
    max-height: 550px;
    overflow-y: auto;
  }

  .sm_btn {
    line-height:   22px;
    margin-top:    11px;
    margin-bottom: 11px;
  }
}

.set_all {
  .set_all_card {
    padding:       10px;
    margin:        10px;
    border:        1px solid $bc_1;
    border-radius: 5px;
    display:       inline-block;
    float:         right;
  }

  .pretty {
    .state {
      color:        $bc_2;
      margin-right: 20px;
    }
  }
}

.table {

  &.table-striped tbody tr:nth-of-type(odd) {
    td {
      background-color: rgba(lighten($bc_5, 15%), 1);
    }
  }

  &.table-striped tbody tr:nth-of-type(even) {
    td {
      background-color: rgba(lighten($bc_5, 20%), 1);
    }
  }

  tr {
    &.gang_leader {
      td {
        background-color: lighten(#FFD734, 25%) !important;
      }
    }
  }

  thead {
    th {
      position:           sticky;
      top:                0;
      background:         white;
      z-index:            30;
      border:             none;
      -webkit-box-shadow: 0 2px 0 0 $bc_2;
      -moz-box-shadow:    0 2px 0 0 $bc_2;
      box-shadow:         0 2px 0 0 $bc_2;

      &.firstName, &.surname, &.jobTitle {
        z-index: 31;
      }

      &.days {
        height:         170px;
        white-space:    nowrap;
        vertical-align: inherit;
      }

      &.days > div {
        transform: translate(-2px, 67px) rotate(285deg);
        width:     30px;
      }

      &.days > div > span {
        padding: 0 5px;
      }
    }
  }

  tfoot {
    position:   -webkit-sticky;
    position:   sticky;
    bottom:     0;
    left:       0;
    background: #666;
    z-index:    99;

    tr, td {
      position:   -webkit-sticky;
      position:   sticky;
      bottom:     0;
      left:       0;
      background: $white;
      z-index:    99;
    }

    td {
      padding: 0;
    }

    td > div {
      padding:       0 0.3rem;
      border-color:  #333333;
      border-width:  6px;
      border-style:  double;
      border-left:   none;
      border-right:  none;
      border-bottom: none;
      margin-bottom: 10px;
    }
  }

  td {
    position:    relative;
    height:      45px;
    line-height: 15px;
    padding:     0 0.3rem;

    .td_data_outer {
      height:   45px;
      display:  block;
      width:    100%;
      position: relative;
    }

    .td_data {
      position:  absolute;
      top:       50%;
      transform: translateY(-50%);
      width:     100%;
    }

    input {
      max-height: 44px;
    }

    textarea {
      padding-top:    0.3rem;
      padding-bottom: 0.3rem;

      &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color:   $bc_5;
        opacity: 1; /* Firefox */
      }

      &:-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: $bc_5;
      }

      &::-ms-input-placeholder { /* Microsoft Edge */
        color: $bc_5;
      }
    }

    input, textarea {
      border:        1px solid darken($bc_5, 5%);
      display:       block;
      height:        100%;
      width:         100%;
      min-height:    44px;
      padding-left:  0.3rem;
      padding-right: 0.3rem;
      color:         #212529;

      &:focus {
        outline:    none;
        box-shadow: 0 0 10px $bc_3;
      }
    }

    .multiselect {
      width:      calc(100% - 2px);
      min-height: 42px;
      height:     42px;
      border:     1px solid darken($bc_5, 5%);

      .multiselect__tags {
        min-height:    42px;
        border-bottom: none;

        input {
          width:      100% !important;
          border:     none;
          min-height: 42px;

          &:focus {
            box-shadow: none;
          }
        }
      }

      .multiselect__input, .multiselect__single {
        padding-top: 13px;
      }
    }

    .multiselect--active {
      input {
        padding-top: 2px;
      }
    }

    &.firstName, &.surname, &.jobTitle, &.running_totals {
      z-index: 28;
    }

    &.days, &.additionsDesc, &.deductionsDesc {
      padding: 0;
    }

    &.releaseRetention, &.backNextWeek {
      font-size: 1.25rem;
      /*z-index:   27;*/
    }

    &.submitPayroll {
      font-size: 1.25rem;
    }
  }

  .firstName, .surname, .jobTitle, .running_totals {
    min-width: 115px;
    position:  sticky;
    left:      0;
    /*z-index:    85;*/
    //background: $white;
  }

  .surname {
    left: 115px;
  }

  //.running_totals {
  //  min-width: 300px;
  //}

  .jobTitle {
    left: 230px;
  }

  .payRate {
    max-width: 110px;
    min-width: 110px;
  }

  .days {
    max-width: 60px;
    min-width: 60px;
  }

  .totalHours, .releaseRetention, .releaseRetentionAmount {
    text-align: center;
    min-width:  100px;

    .td_data {
      left:      50%;
      transform: translate(-50%, -50%);
    }
  }

  .releaseRetention, .releaseRetentionAmount {
    min-width: 80px;
  }

  .hours_invoice {
    text-align: center;
    min-width:  75px;

    .td_data {
      left:      50%;
      transform: translate(-50%, -50%);
    }
  }

  .additionsDesc, .deductionsDesc {
    max-width: 230px;
    min-width: 230px;
  }

  .backNextWeek {
    max-width:  75px;
    min-width:  75px;
    position:   sticky;
    left:       0;
    /*z-index:    30;*/
    //background: white;
    text-align: center;
  }

  .submitPayroll {
    max-width:  75px;
    min-width:  75px;
    text-align: center;
  }

  .totals_row {
    td {
      border-color:  $bc_2;
      border-width:  6px;
      border-style:  double;
      border-left:   none;
      border-right:  none;
      border-bottom: none;
      background:    white;
    }

    .td_data {
      font-weight: bold;
    }

    .days, .additionsDesc, .deductionsDesc {
      padding-left:  0.3rem;
      padding-right: 0.3rem;
    }
  }
}
</style>
